"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.splitProps = void 0;
/**
 * Allows you to pass in a styled-system function and split out
 * in a typesafe manner, the props that match and do not match
 * the styled function.
 */
var splitProps = function splitProps(mixin) {
  var re = new RegExp("^(".concat(mixin.propNames.join("|"), ")$"));
  return function (props) {
    var leftProps = {};
    var rightProps = {};
    for (var _i = 0, _Object$keys = Object.keys(props); _i < _Object$keys.length; _i++) {
      var key = _Object$keys[_i];
      if (re.test(key)) {
        leftProps[key] = props[key];
        continue;
      }
      rightProps[key] = props[key];
    }
    return [leftProps, rightProps];
  };
};
exports.splitProps = splitProps;
//# sourceMappingURL=splitProps.js.map